export default { sha: 'b53a1495d792b6b94260d52e81df8049464607a0', buildNumber: 'undefined' }
